const events = {};
export const ALL_EVENT = 'all'; // 监听全部事件
/**
 * 绑定事件
 * @param name
 * @param self
 * @param callback
 */
function on(name, self, callback) {
    const tuple = [self, callback];
    const callbacks = events[name];
    if (Array.isArray(callbacks)) {
        callbacks.push(tuple);
    }
    else {
        events[name] = [tuple];
    }
}
function _remove(name, self = null) {
    const callbacks = events[name];
    if (Array.isArray(callbacks)) {
        if (!self) {
            events[name] = [];
        }
        else {
            events[name] = callbacks.filter((tuple) => tuple[0] !== self);
        }
    }
}
/**
 * 检查是否绑定了事件
 * @param name
 * @returns
 */
function checkOn(name) {
    return events[name] && events[name].length > 0;
}
/**
 * 移除事件
 * @param name
 * @param self
 */
function remove(name, self = null) {
    if (!name) {
        Object.keys(events).forEach((_name) => {
            _remove(_name, self);
        });
    }
    else {
        _remove(name, self);
    }
}
/**
 * 触发事件
 * @param name
 * @param data
 */
function emit(name, data = {}) {
    const callbacks = events[name];
    const allCallbacks = events[ALL_EVENT];
    if (Array.isArray(callbacks)) {
        callbacks.forEach((tuple) => {
            const self = tuple[0];
            const callback = tuple[1];
            callback.call(self, name, data);
        });
    }
    if (Array.isArray(allCallbacks)) {
        allCallbacks.forEach((tuple) => {
            const self = tuple[0];
            const callback = tuple[1];
            callback.call(self, name, data);
        });
    }
}
export default {
    on,
    remove,
    emit,
    checkOn,
    types: {
        ALL_EVENT
    }
};
